export default "__VITE_ASSET__c5b5683b__"